//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { SMSTemplateDisplayItem } from './SMSTemplateDisplayItem';
import { MessageTemplatePlaceholder } from './MessageTemplatePlaceholder';
import { SMSTemplateType } from './Enums';

export class SystemSMSTemplateDisplayItem extends SMSTemplateDisplayItem {
    TemplateTypeName: string | null = null;
    TemplateType: SMSTemplateType = SMSTemplateType.Reminder;
    Default: SMSTemplateDisplayItem | null = null;
    Placeholders: MessageTemplatePlaceholder[] = [];

    constructor(initializer?: Partial<SystemSMSTemplateDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "SystemSMSTemplateDisplayItem";
}
